import { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { type Control } from 'react-hook-form'

import { handlePhonePaste } from '@shared/__HACKS'
import Button from '@shared/ui/button'
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@shared/ui/form'
import Input from '@shared/ui/input'
import MaskedInput from '@shared/ui/input-mask'
import Switch from '@shared/ui/switch'

import styles from './styles.module.scss'

type DeliveryAddressFormFieldsProps = {
  control: Control,
  noTitleInput?: boolean
  noOtherPerson?: boolean
  noCourierComment?: boolean
}

export default function DeliveryAddressFormFields ({
  control,
  noTitleInput = false,
  noOtherPerson = false,
  noCourierComment = false,
}: DeliveryAddressFormFieldsProps) {
  const { t: to } = useTranslation('order')
  const [ showTitleInput, setShowTitleInput ] = useState(false)
  const [ isPrivateHouse, setIsPrivateHouse ] = useState(false)
  const [ otherBuyer, setOtherBuyer ] = useState(false)

  return <>
    <FormField
      control={control}
      name="isPrivateHouse"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Switch
              classNameRoot={styles.root__switch}
              checked={field.value}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                field.onChange(e.target.checked)
                setIsPrivateHouse(e.target.checked)
              }}
            >
              {to('form.private-house')}
            </Switch>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
    {
      !isPrivateHouse && (
        <div className={styles.root__group}>
          <FormField
            control={control}
            name="apartment"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    placeholder={to('form.apartment')}
                    inputSize="large"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="floor"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    placeholder={to('form.floor')}
                    inputSize="large"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="entrance"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    placeholder={to('form.entrance')}
                    inputSize="large"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="intercom"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    placeholder={to('form.intercom')}
                    inputSize="large"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      )
    }
    {
      !noCourierComment && (
        <FormField
          control={control}
          name="comment"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  placeholder={to('order.comment')}
                  inputSize="large"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )
    }
    {
      !noTitleInput && (
        <div className={styles.root__parents}>
          <Button
            className={styles['root__parents-button']}
            size="small"
            theme="grey"
            type="button"
            onClick={() => setShowTitleInput(!showTitleInput)}
          >
            <span className={styles['root__parents-button-icon']}></span>
            {to('address_label')}
          </Button>
          {showTitleInput && (
            <FormField
              control={control}
              name="title"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      {...field}
                      placeholder={to('order.title')}
                      inputSize="large"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          )}
        </div>
      )
    }
    {
      !noOtherPerson && (
        <FormField
          control={control}
          name="otherBuyer"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Switch
                  classNameRoot={styles.root__switch}
                  checked={field.value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    field.onChange(e.target.checked)
                    setOtherBuyer(e.target.checked)
                  }}
                >
                  {to('order.otherBuyer')}
                </Switch>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )
    }
    {
      otherBuyer && (
        <>
          <FormField
            control={control}
            name="otherBuyerName"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    placeholder={to('order.otherBuyerName')}
                    inputSize="large"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="otherBuyerPhone"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <MaskedInput
                    {...field}
                    placeholder="+7 000 000 00 00"
                    inputSize="large"
                    onPaste={handlePhonePaste}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </>
      )
    }</>
}